import React from 'react';

import { Container, StyledButton, TextContainer, TrashIcon } from './styles';

export interface Props {
  value: string;
  onClick?: () => void;
  isEdition?: boolean;
}

const DeleteButton = ({ value, onClick, isEdition }: Props) => (
  <Container isEdition={isEdition}>
    <StyledButton type="button" onClick={onClick}>
      <TextContainer>
        {value}
        <TrashIcon src="/images/trash-can.svg" />
      </TextContainer>
    </StyledButton>
  </Container>
);

export default DeleteButton;
